"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObservableQueryRPCStatus = void 0;
const chain_rpc_query_1 = require("../../chain-rpc-query");
const unit_1 = require("@keplr-wallet/unit");
class ObservableQueryRPCStatus extends chain_rpc_query_1.ObservableChainQueryRPC {
    constructor(kvStore, chainId, chainGetter) {
        super(kvStore, chainId, chainGetter, "/status");
    }
    get network() {
        if (!this.response) {
            return undefined;
        }
        return this.response.data.result.node_info.network;
    }
    get latestBlockHeight() {
        if (!this.response) {
            return undefined;
        }
        return new unit_1.Int(this.response.data.result.sync_info.latest_block_height);
    }
}
exports.ObservableQueryRPCStatus = ObservableQueryRPCStatus;
//# sourceMappingURL=index.js.map